<template>
  <div v-loading.fullscreen.lock="loading">
    <h1 class="page-title"></h1>

    <div class="row">
      <div class="col-md-12">
        <div class="portlet light portlet-fit bordered">
          <div class="portlet-title">
            <div class="caption">
              <i class="icon-link font-green-haze"></i>
              <span class="caption-subject font-green-haze bold uppercase">Link customer to deal</span>
            </div>
          </div>
          <div class="portlet-body">
            <div class="row">
              <div class="col-md-6">
                <tuango-user-search @onCustomerFound="onCustomer"></tuango-user-search>
              </div>
              <div class="col-md-6 margin-above-desktop">
                <tuango-deal-search @select="onDeal"></tuango-deal-search>
              </div>
            </div>

            <div class="row">
              <div class="col-12-sm" style="margin-top: 15px; padding-right: 15px">
                <button class="btn blue btn-outline sbold uppercase pull-right"
                        @click="link"
                        :disabled="!customer || !deal">Link</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-sm-6">
        <transition name="el-zoom-in-center">
          <div v-if="customer">
            <tuango-user-profile :key="customer.id"
                                 :uid="customer.id"
                                 :name="`${customer.firstName} ${customer.lastName}`"
                                 :email="customer.email"
                                 :source="customer.source"
                                 :avatar="customer.avatar"
                                 :show-user-menu="false"
            />
          </div>
        </transition>
      </div>
      <div class="col-lg-4 col-sm-6">
        <transition name="el-zoom-in-center">
          <div class="mt-element-card mt-element-overlay"
               style="background-color: #fff"
               v-if="deal">
            <tuango-deal-card :dealId="deal.id"
                              :title="deal.title"
                              :description="deal.description|truncate(150)"
                              :img="deal.images ? deal.images[0].url : ''"
                              :dealData="deal"
            />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  // Transformers
  import DealTransformer from '@/app/transformers/DealTransformer'

  // Components
  import TuangoUserSearch from '@/app/components/user/Search'
  import TuangoUserProfile from '@/app/components/user/Profile'
  import TuangoDealSearch from '@/app/components/deal/Search'
  import TuangoDealCard from '@/app/components/deal/DealCard'

  export default {
    name: 'user-link-to-offer',
    components: {
      TuangoUserSearch,
      TuangoUserProfile,
      TuangoDealSearch,
      TuangoDealCard
    },
    data () {
      return {
        customer: null,
        deal: null,
        loading: false
      }
    },
    methods: {
      onCustomer (customers) {
        this.customer = customers[0]
      },
      onDeal (deal) {
        DealTransformer.fetch(deal)
          .then(deal => {
            this.deal = deal
          })
      },
      link () {
        this.$apij.adminlinkcustomertodealPost({}, {
          'cust_uid': this.customer.cust_uid,
          'deal_uid': this.deal.dealId
        })
          .then(res => {
            this.$notify.success({
              title: 'Success',
              message: `${this.customer.firstName} ${this.customer.lastName} was successfully linked to ${this.deal.title}`
            })
          })
          .catch(err => {
            let errorMsg

            switch (err.response.status) {
              case 500:
                errorMsg = this.$t('Error linking customer to deal')
                break
              case 400:
                errorMsg = this.$t('Missing or bad input parameters')
                break
              case 404:
                errorMsg = this.$t('No cards on file.')
                break
              case 410:
                errorMsg = this.$t('Deal cannot be claimed.')
                break
              case 422:
                errorMsg = this.$t('Customer already linked to deal.')
                break
              default:
                errorMsg = this.$t('Unknown error.')
            }

            this.$notify.error({
              title: `Oops! Error ${err.response.status}`,
              message: `${errorMsg}`
            })
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .margin-above-desktop {
    @media (max-width: 991px) {
      margin-top: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/pages/User/LinkToDeal.vue